import {
	createStore,
	createHook,
	type Action,
	createContainer,
	createActionsHook,
} from '@atlassian/react-sweet-state';
import type { State, Key } from './types';

const CLEAR_DELAY = 300;

const initialState: State = {
	issue: {
		index: undefined,
		isIndexLocked: false,
		timeoutId: undefined,
	},
	field: {
		index: undefined,
		isIndexLocked: false,
		timeoutId: undefined,
	},
};

const actions = {
	setIndex:
		(key: Key, index: number): Action<State> =>
		({ setState, getState, dispatch }) => {
			setState({
				[key]: {
					...getState()[key],
					index,
				},
			});
			dispatch(actions.lockIndex(key));
		},
	clearIndex:
		(key: Key): Action<State> =>
		({ setState, getState, dispatch }) => {
			setState({
				[key]: {
					...getState()[key],
					index: undefined,
				},
			});
			dispatch(actions.unlockIndex(key));
		},
	clearIndexAfterDelay:
		(key: Key): Action<State> =>
		({ setState, getState, dispatch }) => {
			const timeoutId = setTimeout(() => {
				if (!getState()[key].isIndexLocked) {
					dispatch(actions.clearIndex(key));
					setState({
						[key]: {
							...getState()[key],
							timeoutId: undefined,
						},
					});
				}
			}, CLEAR_DELAY);
			setState({
				[key]: {
					...getState()[key],
					isIndexLocked: false,
					timeoutId,
				},
			});
		},
	lockIndex:
		(key: Key): Action<State> =>
		({ setState, getState }) => {
			const { timeoutId } = getState()[key];
			if (timeoutId) {
				clearTimeout(timeoutId);
			}
			setState({
				[key]: {
					...getState()[key],
					isIndexLocked: true,
					timeoutId: undefined,
				},
			});
		},
	unlockIndex:
		(key: Key): Action<State> =>
		({ setState, getState }) => {
			setState({
				[key]: {
					...getState()[key],
					isIndexLocked: false,
				},
			});
		},
};

export const InlineCreateContainer = createContainer();

const Store = createStore({
	initialState,
	actions,
	name: 'JwmListInlineCreate',
	containedBy: InlineCreateContainer,
});

export const useInlineCreateContext = createHook(Store);
export const useInlineCreateActions = createActionsHook(Store);

const getInlineIssueCreate = (state: State) => state.issue;
const getInlineFieldCreate = (state: State) => state.field;

export const useInlineIssueCreateContext = createHook(Store, {
	selector: getInlineIssueCreate,
});

export const useInlineFieldCreateContext = createHook(Store, {
	selector: getInlineFieldCreate,
});
